import React, {useState, useEffect} from "react"
import gtReskinLogo from "../../../../assets/svg/groundtruth-logo-hamburger.svg"
import gtReskinText from "../../../../assets/svg/groundtruth-text.svg"
import "./AvailableApps.scss"
import config from "../../../../config"
import {UseStores} from "../../../../hooks/UseStores"

export const AvailableApps = () => {
  const {authDataStore} = UseStores()
  const availableApps = authDataStore.availableApps

  const applications = {
    MF: {
      text: "Ads Manager",
      url: config.available_apps.ADS_MANAGER_URL,
    },
    CAB: {
      text: "Audience Manager",
      url: config.available_apps.AUDIENCE_MANAGER_URL,
    },
    LM: {
      text: "Location Manager",
      url: config.available_apps.LOCATION_MANAGER_URL,
    },
    RA: {
      text: "Console",
      url: config.available_apps.CONSOLE_URL,
    },
  }

  const [iconsToRender, setIconsToRender] = useState([])

  useEffect(() => {
    const renderIcons = () => {
      const icons = Object.keys(applications)
        .filter((appCode) => availableApps.includes(appCode))
        .map((appCode) => ({
          key: appCode,
          url: applications[appCode].url,
          text: applications[appCode].text,
        }))
      setIconsToRender(icons)
    }

    renderIcons()
  }, [])

  return (
    <div className="available-apps">
      {iconsToRender.map((icon) => (
        <div key={icon.key} className="available-apps-container">
          <button onClick={() => window.open(icon.url, "_blank")}>
            <div className="app-logo-container">
              <div className="available-apps__img-container">
                <img src={gtReskinLogo} alt="GroundTruth" className="groundtruth-logo" />
              </div>
            </div>
            <div className="gt-img-container">
              <img src={gtReskinText} alt="GroundTruth" />
            </div>
            <p className="app-name">{icon.text}</p>
          </button>
        </div>
      ))}
    </div>
  )
}
